import axios from 'axios'
import JSONbig from 'json-bigint'
import { Message } from 'element-ui';
import Cookies from "@/utils/cookie";
import $utils from "@/utils/utils";
import $dic from "./hostInfo.js";


/* *
  * url: 请求地址
  * oSend: 请求参数
  * oData.isLogin: 请求是否需要登录token，默认登录
  * oData.method: 请求方式
  * oData.oss: oss上传图片
  * oData.msg: true不提示全部返回
  * oData.err: true不提示网络请求失败
  * oData.t: true添加时间戳
  * */
export default async (url, oSend, oData) => {
    if (!url) { return false }
    let urls = '';
    let oSends = paramsUndefined(oSend) || {};
    let oDatas = oData || {};
    if (!oDatas.t) {
        if (!oDatas.method) { url = `${url}?t=${(new Date()).valueOf().toString()}` }
        if (oDatas.method == 'get') { oSends.t = (new Date()).valueOf().toString() }
    }
    // process.env.NODE_ENV === "development" 开发环境
    if (process.env.NODE_ENV === "development") {
        urls = `${oDatas.api || '/api'}${url}`;
        // console.log("开发环境")
    } else {
        urls = `${$dic.url}${url}`;
        // console.log("生产环境")
    }
    if (oDatas.method == 'get' || oDatas.method == 'POSTBLOB' || oDatas.method == 'GETBLOB') { urls = urls + params(oSends); }
    return new Promise((resolve, reject) => {
        let token = Cookies.getCookie('token') || '';
        if (!token && !oDatas.isLogin) {
            console.log('', token, oDatas.isLogin)
            Message({ type: 'error', message: '请先登录' });
            setTimeout(function () {
                window.location.href = '/#/'
            }, 2000);
            return false
        }

        // 默认post请求
        axios.defaults.headers.common["Authorization"] = token;
        let requestConfig = {
            method: oDatas.method || 'post',
            url: urls,
            data: oDatas.param?undefined:oSends,
            params: oDatas.param || undefined,
            headers: { 'Content-Type': 'application/json;charset=UTF-8' },
            responseType: 'json',
            timeout: 20000,
            transformResponse: [
                function (data) {
                    // 对 data 进行任意转换处理
                    try {
                        return JSONbig.parse(data)
                    } catch (err) {
                        return data
                    }

                }
            ]
        };

        // git文件请求配置header头
        if (oDatas.method == 'GETBLOB') {
            requestConfig.method = 'get';
            requestConfig.credentials = 'include';
            requestConfig.responseType = 'blob';
            requestConfig.mode = 'cors';
            requestConfig.timeout = 60000
        }
        // post文件请求配置header头
        if (oDatas.method == 'POSTBLOB') {
            requestConfig.method = 'post';
            requestConfig.credentials = 'include';
            requestConfig.responseType = 'blob';
            requestConfig.mode = 'cors';
            requestConfig.timeout = 60000
        }
        // 上传文件
        if (oDatas.method == 'postImport') {
            const formData = Object.entries(oSend).reduce((t, v) => {
                Reflect.apply(t.append, t, v)
                return t
            }, new FormData())
            requestConfig.method = 'post';
            requestConfig.data = formData;
            requestConfig.params = oDatas.param || {};
            requestConfig.body = {};
            requestConfig.headers = { 'Content-Type': 'multipart/form-data' }
        }
        axios(requestConfig)
            // 请求成功后执行then
            .then((response) => {
                if (oDatas.msg) {
                    resolve(response.data) // 处理后台返回的数据
                } else if (oDatas.method == 'GETBLOB' || oDatas.method == 'POSTBLOB' || oDatas.method == 'postImport') {
                    resolve(response) // 处理后台返回的数据
                } else {
                    if (response.data.code === 200 || response.data.code === '200') {
                        resolve(response.data) // 处理后台返回的数据
                    } else if (response.data.code == 10000006) { // 授权过期
                        Message({ type: 'error', message: response.data.msg || response.data.message });
                        Cookies.removeCookie('token');
                        setTimeout(function () {
                            window.location.reload()
                        }, 1000);
                    } else {
                        Message({ type: 'error', message: response.data.msg || response.data.message });
                        reject(response.data) // 处理后台返回的数据
                    }
                }
            })
            // 请求失败后执行catch
            .catch((err) => {
                console.log('网络请求失败');
                if ((err.response || {}).code == '403') {
                    Message({ type: 'error', message: '请求未授权' });
                    Cookies.removeCookie('token');
                    setTimeout(function () {
                        window.location.href = '/#/'
                    }, 1000);
                } else if (!oDatas.err) {
                    Message({ type: 'error', message: '网络请求失败' });
                }

                reject(err)
            })
    })
}


/* get请求url参数拼接 */
function params(obj) {
    let result = '';
    let item;
    for (item in obj) {
        if ((obj[item] === 0 ? true : obj[item]) && String(obj[item])) {
            result += `&${item}=${obj[item]}`;
        }
    }
    if (result) {
        result = '?' + result.slice(1);
    }
    return result;
}

// 处理空字符串为undefined
function paramsUndefined(obj = {}) {
    let oSends = JSON.parse(JSON.stringify(obj));
    let item;
    for (item in oSends) {
        if (oSends[item] === '') {
            oSends[item] = undefined
        }
    }
    return oSends;
}


// WEBPACK FOOTER //
// ./src/config/apiConfig/api.js